const getWordpressCloudinaryId = (url: string) => {
  const regex = /(?:\/v[0-9]+\/)(.*)$/
  const matches = url.match(regex)
  if (matches) return matches[1]
}

export default getWordpressCloudinaryId
